// Meta (Facebook) pixel events sent directly from the app. The pixel itself is
// initialised in pages/_document.tsx only when IS_FACEBOOK_PIXEL_ENABLED, so
// every helper here is a no-op when `fbq` is missing (non-prod, ad blockers).

// The Meta catalog is a Home Listings catalog (remarketing-catalog.csv from
// cbb-api, keyed by `home_listing_id`), confirmed by the ad agency
// (CBBRR-4456). Meta requires this content_type for real estate catalogs,
// otherwise events are not matched to catalog items.
export const META_CONTENT_TYPE = 'home_listing';

export type ViewContentParams = {
  // Must equal `home_listing_id` in the catalog feed, which is mlsListingId.
  listingId: string;
  name: string;
  price?: number | null;
  city?: string | null;
};

function track(event: string, params: Record<string, unknown>): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') {
    return;
  }
  window.fbq('track', event, params);
}

export function trackViewContent({
  listingId,
  name,
  price,
  city,
}: ViewContentParams): void {
  if (!listingId) return;

  track('ViewContent', {
    content_ids: [listingId],
    content_type: META_CONTENT_TYPE,
    content_name: name,
    // Meta rejects non-numeric values, so only send a real price.
    ...(typeof price === 'number' && Number.isFinite(price) && price > 0
      ? { value: price, currency: 'USD' }
      : {}),
    ...(city ? { city } : {}),
    region: 'Florida',
    country: 'US',
  });
}
